
import CheckoutV3Page, {getStaticProps as getV3StaticProps} from './checkoutv3'

export default function CheckoutPage() {
  return <CheckoutV3Page />
}

export const getStaticProps = async context => {
  const v3Props = await getV3StaticProps(context)

  return {
    ...v3Props,
    props: {
      ...v3Props.props,
      isV3: true
    }
  }
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true
  }
}
